"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Traffic = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Traffic =
/*#__PURE__*/
function () {
  function Traffic() {
    _classCallCheck(this, Traffic);

    this.type = 'custom';
  }

  _createClass(Traffic, [{
    key: "sendEvent",
    value: function sendEvent(eid) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      window._expDataLayer = window && window._expDataLayer ? window._expDataLayer : [];

      window._expDataLayer.push({
        schema: 'add_event',
        version: 'v1',
        data: {
          eid: eid,
          type: this.type,
          properties: properties // dom_element: domElement,
          // dom_event: domEvent,

        }
      });
    }
  }, {
    key: "sendImpression",
    value: function sendImpression(eid) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      window._expDataLayer = window && window._expDataLayer ? window._expDataLayer : [];

      window._expDataLayer.push({
        schema: 'add_impression',
        version: 'v1',
        data: {
          eid: eid,
          properties: properties // dom_element: domElement,

        }
      });
    }
  }]);

  return Traffic;
}();

exports.Traffic = Traffic;

var _default = new Traffic();

exports["default"] = _default;